import { render, staticRenderFns } from "./ProgramListPage.vue?vue&type=template&id=7462d8b2"
import script from "./ProgramListPage.vue?vue&type=script&lang=js"
export * from "./ProgramListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports